<template>
  <div class="tab-content">
    <div class="tab-pane fade show active">
      <el-table
        :data="moderateRiskFunds"
        border
        class="custom-scrollable-table header-color"
        :default-sort="{ prop: 'fiveYearCAGR', order: 'descending' }"
      >
        <el-table-column
          label="Active"
          :width="columnWidth"
          :fixed="isSmallScreen ? 'left' : false"
        >
          <template #header>
            <div style="margin-top: 5px">
              <img
                src="@/assets/images/passive.svg"
                alt="Active"
                class="header-icon"
              />
              Equity - Moderate risk&nbsp;<img
                src="@/assets/images/circle.svg"
                @click="openDialog('Equity - Moderate risk', content1)"
                style="cursor: pointer; margin-bottom: 2px"
              />
            </div>
          </template>

          <template #default="scope">
            <span class="d-flex gap-data prime-etf">
              {{ scope.row.name }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="primeRating"
          label="Ratings"
          width="100"
          sortable
        >
          <template #default="scope">
            <span>
              {{
                scope.row.primeRating === null ||
                scope.row.primeRating === "null"
                  ? "Unrated"
                  : scope.row.primeRating + "★"
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="oneYearReturn"
          label="1 year"
          width="100"
          :sortable="true"
          :sort-method="
            (rowA, rowB) => sortByProperty(rowA, rowB, 'oneYearReturn')
          "
        >
          <template #default="scope">
            <span>{{
              scope.row.oneYearReturn === "0"
                ? "NA"
                : scope.row.oneYearReturn + "%"
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="threeYearCAGR"
          label="3 Years"
          width="100"
          :sortable="true"
          :sort-method="
            (rowA, rowB) => sortByProperty(rowA, rowB, 'threeYearCAGR')
          "
        >
          <template #header>
            <el-tooltip
              content="Returns over 1 year are annualised"
              placement="top"
            >
              <span>3 years</span>
            </el-tooltip>
          </template>
          <template #default="scope">
            <span>{{
              scope.row.threeYearCAGR === "0"
                ? "NA"
                : scope.row.threeYearCAGR + "%"
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="fiveYearCAGR"
          label="5 Years"
          width="100"
          :sortable="true"
          :sort-method="
            (rowA, rowB) => sortByProperty(rowA, rowB, 'fiveYearCAGR')
          "
          style="border-bottom: none !important"
        >
          <template #header>
            <el-tooltip
              content="Returns over 1 year are annualised"
              placement="top"
              popper-class="custom-tooltip"
            >
              <span>5 years</span>
            </el-tooltip>
          </template>
          <template #default="scope">
            <span style="border-bottom: none !important">{{
              scope.row.fiveYearCAGR === "0"
                ? "NA"
                : scope.row.fiveYearCAGR + "%"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Why this ETF" width="150">
          <template #default="scope">
            <span style="padding-left: 26px; display: inline-block">
              {{ scope.row.schemeStrategy }}
              <a
                href="#"
                @click.prevent="showCommentPopup(scope.row)"
                style="color: #01a2d9; cursor: pointer"
              >
                View report
              </a>
              <img
                v-if="scope.row.alert"
                @click="showAlertPopup(scope.row)"
                src="@/assets/images/alert.svg"
                alt="Alert Icon"
                class="funds-popup"
                style="
                  cursor: pointer;
                  margin-left: 8px;
                  vertical-align: text-bottom;
                "
              />
            </span>
          </template>
        </el-table-column>
      </el-table>
      <br />

      <el-table
        :data="highRiskFunds"
        border
        style="width: 100%"
        class="custom-scrollable-table header-aggressive"
        :default-sort="{ prop: 'fiveYearCAGR', order: 'descending' }"
      >
        <el-table-column
          label="Active"
          :width="columnWidth"
          :fixed="isSmallScreen ? 'left' : false"
        >
          <template #header>
            <div style="margin-top: 5px">
              <img
                src="@/assets/images/aggresive.svg"
                alt="Active"
                class="header-icon"
              />
              Equity - High risk &nbsp;<img
                src="@/assets/images/circle.svg"
                @click="openDialog('Equity - High risk', content2)"
                style="cursor: pointer; margin-bottom: 2px"
              />
            </div>
          </template>

          <template #default="scope">
            <span class="d-flex gap-data prime-etf">
              {{ scope.row.name }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="primeRating"
          label="Ratings"
          width="100"
          sortable
        >
          <template #default="scope">
            <span>
              {{
                scope.row.primeRating === null ||
                scope.row.primeRating === "null"
                  ? "Unrated"
                  : scope.row.primeRating + "★"
              }}
            </span>
          </template>
        </el-table-column>

        <el-table-column
          prop="oneYearReturn"
          label="1 year"
          width="100"
          :sortable="true"
          :sort-method="
            (rowA, rowB) => sortByProperty(rowA, rowB, 'oneYearReturn')
          "
        >
          <template #default="scope">
            <span>{{
              scope.row.oneYearReturn === "0"
                ? "NA"
                : scope.row.oneYearReturn + "%"
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="threeYearCAGR"
          label="3 Years"
          width="100"
          :sortable="true"
          :sort-method="
            (rowA, rowB) => sortByProperty(rowA, rowB, 'threeYearCAGR')
          "
        >
          <template #header>
            <el-tooltip
              content="Returns over 1 year are annualised"
              placement="top"
            >
              <span>3 years</span>
            </el-tooltip>
          </template>
          <template #default="scope">
            <span>{{
              scope.row.threeYearCAGR === "0"
                ? "NA"
                : scope.row.threeYearCAGR + "%"
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="fiveYearCAGR"
          label="5 Years"
          width="100"
          :sortable="true"
          :sort-method="
            (rowA, rowB) => sortByProperty(rowA, rowB, 'fiveYearCAGR')
          "
        >
          <template #header>
            <el-tooltip
              content="Returns over 1 year are annualised"
              placement="top"
            >
              <span>5 years</span>
            </el-tooltip>
          </template>
          <template #default="scope">
            <span style="border-bottom: none !important">{{
              scope.row.fiveYearCAGR === "0"
                ? "NA"
                : scope.row.fiveYearCAGR + "%"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Why this ETF" width="150">
          <template #default="scope">
            <span style="padding-left: 26px; display: inline-block">
              {{ scope.row.schemeStrategy }}
              <a
                href="#"
                @click.prevent="showCommentPopup(scope.row)"
                style="color: #01a2d9; cursor: pointer"
              >
                View report
              </a>
              <img
                v-if="scope.row.alert"
                @click="showAlertPopup(scope.row)"
                src="@/assets/images/alert.svg"
                alt="Alert Icon"
                class="funds-popup"
                style="
                  cursor: pointer;
                  margin-left: 8px;
                  vertical-align: text-bottom;
                "
              />
            </span>
          </template>
        </el-table-column>
      </el-table>
      <br />
      <el-table
        :data="themeFunds"
        border
        style="width: 100%"
        class="custom-scrollable-table header-aggressive"
        :default-sort="{ prop: 'fiveYearCAGR', order: 'descending' }"
      >
        <el-table-column
          label="Active"
          :width="columnWidth"
          :fixed="isSmallScreen ? 'left' : false"
        >
          <template #header>
            <div style="margin-top: 5px">
              <img
                src="@/assets/images/aggresive.svg"
                alt="Active"
                class="header-icon"
              />
              Equity - Strategy & Thematic&nbsp;<img
                src="@/assets/images/circle.svg"
                @click="openDialog('Equity - Strategy & Thematic', content3)"
                style="cursor: pointer; margin-bottom: 2px"
              />
            </div>
          </template>

          <template #default="scope">
            <span class="d-flex gap-data prime-etf">
              {{ scope.row.name }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="primeRating"
          label="Ratings"
          width="100"
          sortable
        >
          <template #default="scope">
            <span>
              {{
                scope.row.primeRating === null ||
                scope.row.primeRating === "null"
                  ? "Unrated"
                  : scope.row.primeRating + "★"
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="oneYearReturn"
          label="1 year"
          width="100"
          :sortable="true"
          :sort-method="
            (rowA, rowB) => sortByProperty(rowA, rowB, 'oneYearReturn')
          "
        >
          <template #default="scope">
            <span>{{
              scope.row.oneYearReturn === "0"
                ? "NA"
                : scope.row.oneYearReturn + "%"
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="threeYearCAGR"
          label="3 Years"
          width="100"
          :sortable="true"
          :sort-method="
            (rowA, rowB) => sortByProperty(rowA, rowB, 'threeYearCAGR')
          "
        >
          <template #header>
            <el-tooltip
              content="Returns over 1 year are annualised"
              placement="top"
            >
              <span>3 years</span>
            </el-tooltip>
          </template>
          <template #default="scope">
            <span>{{
              scope.row.threeYearCAGR === "0"
                ? "NA"
                : scope.row.threeYearCAGR + "%"
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="fiveYearCAGR"
          label="5 Years"
          width="100"
          :sortable="true"
          :sort-method="
            (rowA, rowB) => sortByProperty(rowA, rowB, 'fiveYearCAGR')
          "
        >
          <template #header>
            <el-tooltip
              content="Returns over 1 year are annualised"
              placement="top"
            >
              <span>5 years</span>
            </el-tooltip>
          </template>
          <template #default="scope">
            <span style="border-bottom: none !important">{{
              scope.row.fiveYearCAGR === "0"
                ? "NA"
                : scope.row.fiveYearCAGR + "%"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Why this ETF" width="150">
          <template #default="scope">
            <span style="padding-left: 26px; display: inline-block">
              {{ scope.row.schemeStrategy }}
              <a
                href="#"
                @click.prevent="showCommentPopup(scope.row)"
                style="color: #01a2d9; cursor: pointer"
              >
                View report
              </a>
              <img
                v-if="scope.row.alert"
                @click="showAlertPopup(scope.row)"
                src="@/assets/images/alert.svg"
                alt="Alert Icon"
                class="funds-popup"
                style="
                  cursor: pointer;
                  margin-left: 8px;
                  vertical-align: text-bottom;
                "
              />
            </span>
          </template>
        </el-table-column>
      </el-table>
      <br />

      <el-table
        :data="debtGoldFunds"
        border
        style="width: 100%"
        class="custom-scrollable-table header-color"
        :default-sort="{ prop: 'fiveYearCAGR', order: 'descending' }"
      >
        <el-table-column
          label="Active"
          :width="columnWidth"
          :fixed="isSmallScreen ? 'left' : false"
        >
          <template #header>
            <div style="margin-top: 5px">
              <img
                src="@/assets/images/passive.svg"
                alt="Active"
                class="header-icon"
              />
              Debt & Gold&nbsp;<img
                src="@/assets/images/circle.svg"
                @click="openDialog('Debt & Gold', content4)"
                style="cursor: pointer; margin-bottom: 2px"
              />
            </div>
          </template>

          <template #default="scope">
            <span class="d-flex gap-data prime-etf">
              {{ scope.row.name }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="primeRating"
          label="Ratings"
          width="100"
          sortable
        >
          <template #default="scope">
            <span>
              {{
                scope.row.primeRating === null ||
                scope.row.primeRating === "null"
                  ? "Unrated"
                  : scope.row.primeRating + "★"
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="oneYearReturn"
          label="1 year"
          width="100"
          :sortable="true"
          :sort-method="
            (rowA, rowB) => sortByProperty(rowA, rowB, 'oneYearReturn')
          "
        >
          <template #default="scope">
            <span>{{
              scope.row.oneYearReturn === "0"
                ? "NA"
                : scope.row.oneYearReturn + "%"
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="threeYearCAGR"
          label="3 Years"
          width="100"
          :sortable="true"
          :sort-method="
            (rowA, rowB) => sortByProperty(rowA, rowB, 'threeYearCAGR')
          "
        >
          <template #header>
            <el-tooltip
              content="Returns over 1 year are annualised"
              placement="top"
            >
              <span>3 years</span>
            </el-tooltip>
          </template>
          <template #default="scope">
            <span>{{
              scope.row.threeYearCAGR === "0"
                ? "NA"
                : scope.row.threeYearCAGR + "%"
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="fiveYearCAGR"
          label="5 Years"
          width="100"
          :sortable="true"
          :sort-method="
            (rowA, rowB) => sortByProperty(rowA, rowB, 'fiveYearCAGR')
          "
        >
          <template #header>
            <el-tooltip
              content="Returns over 1 year are annualised"
              placement="top"
            >
              <span>5 years</span>
            </el-tooltip>
          </template>
          <template #default="scope">
            <span style="border-bottom: none !important">{{
              scope.row.fiveYearCAGR === "0"
                ? "NA"
                : scope.row.fiveYearCAGR + "%"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Why this ETF" width="150">
          <template #default="scope">
            <span style="padding-left: 26px; display: inline-block">
              {{ scope.row.schemeStrategy }}
              <a
                href="#"
                @click.prevent="showCommentPopup(scope.row)"
                style="color: #01a2d9; cursor: pointer"
              >
                View report
              </a>
              <img
                v-if="scope.row.alert"
                @click="showAlertPopup(scope.row)"
                src="@/assets/images/alert.svg"
                alt="Alert Icon"
                class="funds-popup"
                style="
                  cursor: pointer;
                  margin-left: 8px;
                  vertical-align: text-bottom;
                "
              />
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog
        v-model="isDialogVisible"
        class="fw-bold dialog-color"
        :title="dialogTitle"
        :width="popupwidth"
      >
        <p>{{ dialogContent }}</p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isDialogVisible = false" class="v-btn btn-color"
            >Close</el-button
          >
        </span>
      </el-dialog>
      <el-dialog
        v-model="isAlertDialog"
        class="fw-bold dialog-color alert-align"
        :width="popupwidth"
      >
        <template #header>
          <div style="display: flex; align-items: center; gap: 8px">
            <font-awesome-icon
              :icon="['fas', 'circle-exclamation']"
              class="funds-popup"
              style="color: #01a2d9; font-size: 1.5em"
            />
            <span>Alert</span>
          </div>
          <p>{{ dialogTitle }}</p>
        </template>
        <p>{{ alert.message }}</p>
      </el-dialog>
      <el-dialog
        v-model="isCommentPopupVisible"
        :width="popupwidth"
        class="dialog-color"
      >
        <template #title>
          <div class="fw-bold">
            <h3>{{ selectedFund.name }}</h3>
          </div>
        </template>
        <p class="fw-bold">Research report</p>
        <hr />
        <div v-html="selectedFund.comment"></div>
        <div class="d-flex justify-content-center">
          <el-button
            @click="isCommentPopupVisible = false"
            class="v-btn btn-color"
          >
            Close
          </el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script setup>
import { onMounted, computed, ref, onBeforeUnmount } from "vue";
import { useStore } from "vuex";

const store = useStore();
const isSmallScreen = ref(false);
const columnWidth = computed(() => (isSmallScreen.value ? 270 : 350));
const popupwidth = computed(() => (isSmallScreen.value ? "100%" : "50%"));
const debtGoldFunds = computed(() => store.getters.getDebtGoldData);
const highRiskFunds = computed(() => store.getters.getHighRiskFunds);
const moderateRiskFunds = computed(() => store.getters.getModerateRiskFunds);
const themeFunds = computed(() => store.getters.getThemeFunds);

const checkScreenSize = () => {
  isSmallScreen.value = window.innerWidth <= 768;
};
function sortByProperty(rowA, rowB, property) {
  const numA = parseFloat(rowA[property]);
  const numB = parseFloat(rowB[property]);

  if (isNaN(numA)) return 1;
  if (isNaN(numB)) return -1;

  return numA - numB;
}
onBeforeUnmount(() => {
  window.removeEventListener("resize", checkScreenSize);
});

const isDialogVisible = ref(false);
const isAlertDialog = ref(false);
const dialogContent = ref("");
const dialogTitle = ref("");
const content1 = `These are ETFs that track large-cap focused equity market indexes. The indexes are a mix of primary market-cap based ones and more specialised ones such as factor-based indexes. These ETFs suit any investor and can form part of long-term equity portfolios. Hold these ETFs for at least 5 years`;
const content2 = `These are ETFs that track high-volatile, high-return indexes. These indexes span the broad market, or the mid-cap/small-cap segment or feature indexes that can rally sharply on market upswings or also fall sharply in market downturns. These ETFs suit moderate to high-risk investors. Hold these ETFs for at least 5 years`;
const content3 = `These are ETFs that track sector-specific, thematic, or strategy-based indexes. These ETFs are high risk and are best used as diversifiers or return-boosters in a portfolio. They need timed exits`;
const content4 = `These are ETFs that track debt indexes or domestic gold prices. These ETFs are best used for asset-allocation purposes or as a hedge to equity volatility, for any investor`;

const openDialog = (title, content) => {
  dialogTitle.value = title;
  dialogContent.value = content;
  isDialogVisible.value = true;
};

onMounted(() => {
  store.dispatch("fetchFunds");
  checkScreenSize();
  window.addEventListener("resize", checkScreenSize);
});

const selectedFund = ref({
  name: "",
  category: "",
  comment: "",
});
const alert = ref({ message: "" });
const isCommentPopupVisible = ref(false);
const showAlertPopup = (fund) => {
  isAlertDialog.value = true;
  dialogTitle.value = fund.name;
  alert.value.message = fund.alert;
};

const showCommentPopup = (fund) => {
  isCommentPopupVisible.value = true;
  selectedFund.value.name = fund.name;
  selectedFund.value.category = fund.category;
  selectedFund.value.comment = fund.comment;
};
</script>

<style scoped>
.prime-etf {
  position: relative;
}

.header-icon {
  width: 45px;
  height: 40px;
  margin-bottom: 7px;
}

::v-deep(.el-table .descending .sort-caret.descending) {
  border-top-color: white !important;
}

::v-deep(.el-table .ascending .sort-caret.ascending) {
  border-bottom-color: white !important;
}

.funds-popup {
  width: 16px;
  height: 16px;
  margin-right: 5px;
  cursor: pointer;
}

.header-color {
  --el-table-header-bg-color: #0377a6;
}
.header-aggressive {
  --el-table-header-bg-color: #012e40;
}

.btn-color {
  background: #00a3d9 !important;
  border-radius: 10px;
  color: white !important;
  padding: 20px;
  border-color: unset !important;
}

.gap-data {
  column-gap: 5px;
  padding: 10px;
}

.custom-scrollable-table {
  --el-table-header-text-color: white;
  --el-table-header-font-weight: bold;
  --el-table-border-color: none;
  border: 1px solid black;
  position: relative;
  overflow: hidden;
  border-collapse: collapse;
}

@media (min-width: 769px) {
  .custom-scrollable-table {
    border-radius: 10px;
  }
}

::v-deep(.el-table .el-table__cell),
::v-deep(.el-table .cell) {
  padding: 0px !important;
}

::v-deep(.custom-scrollable-table tbody tr:last-child td) {
  border-bottom: none;
}

::v-deep(.custom-scrollable-table .el-table__header-wrapper thead tr th) {
  font-size: larger;
}

::v-deep(.custom-scrollable-table .el-table__header-wrapper thead tr th),
::v-deep(.custom-scrollable-table .el-table__body-wrapper td) {
  text-align: center !important;
}

::v-deep(.custom-scrollable-table .el-table__header-wrapper th:first-child),
::v-deep(.custom-scrollable-table .el-table__body-wrapper td:first-child),
::v-deep(.custom-scrollable-table .el-table__body-wrapper td:last-child) {
  text-align: left !important;
}

::v-deep(.custom-scrollable-table tbody tr td) {
  border-bottom: 0.5px solid black;
  border-right: 0.5px solid black;
  margin: 10px !important;
}

::v-deep(.custom-scrollable-table thead tr th) {
  border-bottom: 0.5px solid black;
  border-right: 0.5px solid black;
}

::v-deep(.custom-scrollable-table thead tr th:last-child),
::v-deep(.custom-scrollable-table tbody tr td:last-child) {
  border-right: none;
}

@media (max-width: 768px) {
  ::v-deep(.custom-scrollable-table thead tr th:first-child),
  ::v-deep(.custom-scrollable-table tbody tr td:first-child) {
    filter: drop-shadow(4px 4px 10px rgba(0, 0, 0, 0.25));
  }
}

::v-deep(.el-table__body, .el-table__footer) {
  margin: 0 !important;
}

::v-deep(.el-table__header),
::v-deep(.el-table__body) {
  margin: 0 !important;
  width: 100% !important;
}

::v-deep(.dialog-color .el-dialog__header .el-dialog__headerbtn) {
  background: white !important;
}

::v-deep(.alert-align .el-dialog__header) {
  padding-bottom: 0;
}
</style>
